import { cx } from './ui';

/** Treble clef outline (Bravura gClef U+E050, SIL OFL) as an inline SVG — crisp at any size, no font metrics. */
const CLEF_PATH = 'M376 683C374 671 376 670 382 664C490 563 572 436 572 283C572 196 548 110 507 50C492 28 466 0 455 0C441 0 410 26 390 48C316 130 292 255 292 359C292 417 299 482 306 523C308 535 309 537 297 547C153 666 0 809 0 1011C0 1185 119 1350 364 1350C387 1350 413 1348 433 1344C444 1342 446 1341 448 1353C460 1420 475 1507 475 1554C475 1702 375 1720 316 1720C262 1720 236 1704 236 1691C236 1684 245 1681 268 1674C299 1665 335 1638 335 1580C335 1525 300 1478 239 1478C172 1478 132 1531 132 1593C132 1658 171 1756 322 1756C389 1756 519 1726 519 1556C519 1499 501 1404 490 1342C488 1330 489 1331 503 1325C604 1285 671 1200 671 1087C671 959 577 846 430 846C404 846 404 846 401 828M470 155C503 155 530 182 530 237C530 348 435 438 356 507C349 513 345 512 343 499C339 473 337 439 337 407C337 251 409 155 470 155M361 836C364 855 364 854 346 860C258 890 201 969 201 1054C201 1144 248 1208 316 1231C324 1234 336 1237 343 1237C351 1237 355 1232 355 1226C355 1219 347 1216 340 1213C298 1195 268 1152 268 1106C268 1049 307 1006 368 989C384 985 386 986 388 997L438 1295C440 1306 439 1306 424 1309C408 1312 388 1314 368 1314C193 1314 80 1217 80 1078C80 1019 90 940 173 846C233 779 279 742 326 704C336 696 338 697 340 708M430 995C428 983 429 980 441 981C522 988 589 1056 589 1144C589 1207 551 1258 495 1286C483 1292 481 1292 479 1280';

export function ClefMark({ className, size = 36 }: { className?: string; size?: number }) {
  return (
    <svg
      aria-hidden
      viewBox="0 0 671 1756"
      height={size}
      width={(size * 671) / 1756}
      className={cx('inline-block shrink-0', className)}
      fill="currentColor"
    >
      <path d={CLEF_PATH} />
    </svg>
  );
}

export function Wordmark({ compact, className }: { compact?: boolean; className?: string }) {
  return (
    <span className={cx('inline-flex items-center gap-2 text-[var(--accent)]', className)}>
      <ClefMark size={compact ? 38 : 52} />
      <span className="flex flex-col font-display leading-[0.95] font-black tracking-tight uppercase">
        <span className={compact ? 'text-[15px]' : 'text-[19px]'}>Karlakór</span>
        <span className={compact ? 'text-[15px]' : 'text-[19px]'}>Grafarvogs</span>
      </span>
    </span>
  );
}
